import Vue from 'vue'
import VueRouter from 'vue-router'
import format from "date-fns/format"
import routeNames from "@/router/RouteNames";
import store from "@/store";



Vue.use(VueRouter)
const today = format(new Date(), 'yyyy-MM-dd')

const routes = [
    {
        path: '/login',
        name: routeNames.LOGIN,
        component: () => import('@/views/Login.vue'),
        meta: {title: 'Login',
        requiresAuth: false}
    },
    {
        path: '/503',
        name: 'ServiceUnavailable',
        component: () => import('@/views/SiteDown.vue'),
    },
    {
        path: '/gdpr',
        name: routeNames.GDPR,
        component: () => import('@/views/Gdpr.vue'),
        meta: {requiresAuth: false} // make sure it's public
    },
    {
        path: '/registratie',
        name: routeNames.REGISTRATIE_FORMULIER,
        component: () => import('@/components/formulieren/RegistratieForm'),
        meta: {requiresAuth: false} // make sure it's public
    },
    {
        path: '/',
        name: '',
        component: () => import('@/views/HomeView'),
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                redirect: () => ({
                    name: routeNames.KALENDER,
                    params: { date: format(new Date(), 'yyyy-MM-dd') }
                })
            },
            {
                path: 'kalender/:date',
                name: routeNames.KALENDER,
                component: () => import('@/views/Kalender'),
                meta: {
                    title: 'Waarnemingen',
                    requiresAuth: true
                }
            },
            {
                path: 'kalender/toevoegen/:date',
                name: routeNames.WAARNEMING_TOEVOEGEN,
                component: () => import('@/components/waarnemingen/InputWaarneming.vue'),
                props: route => ({
                    date: route.params.date,
                    bestaandeWaarneming: route.query.bestaandeWaarneming
                        ? JSON.parse(decodeURIComponent(route.query.bestaandeWaarneming))
                        : null
                }),
                meta: {
                    title: 'Waarneming',
                    requiresAuth: true
                }
            },
            {
                path: 'kalender/waarneming/:date',
                name: routeNames.WAARNEMING_VAN_DAG,
                component: () => import('@/components/homepage/ObservatiesDag'),
                meta: {
                    title: 'Waarneming',
                    requiresAuth: true
                }
            },
            {
                path: 'waarnemingen/waarnemer/:id',
                name: routeNames.WAARNEMINGEN_WAARNEMER_FORM,
                component: () => import('@/components/formulieren/DatumSelectie'),
                meta: {
                    title: 'Overzicht',
                    requiresAuth: true
                }
            },
            {
                path: 'waarnemingen/waarnemer/:id/wolfoverzicht',
                name: routeNames.WAARNEMINGEN_WAARNEMER_WOLF,
                component: () => import('@/components/waarnemingen/OverzichtWaarnemingen'),
                props: (route) => ({
                    id: route.params.id,
                    type: 'wolf'
                }),
                meta: {
                    title: 'Wolfgetal',
                    requiresAuth: true
                }
            },
            {
                path: 'waarnemingen/waarnemer/:id/beckoverzicht',
                name: routeNames.WAARNEMINGEN_WAARNEMER_BECK,
                component: () => import('@/components/waarnemingen/OverzichtWaarnemingen'),
                props: (route) => ({
                    id: route.params.id,
                    type: 'beck'
                }),
                meta: {
                    title: 'Beck',
                    requiresAuth: true
                }
            },
            {
                path: 'waarnemingen/waarnemer/:id/cvoverzicht',
                name: routeNames.WAARNEMINGEN_WAARNEMER_CV,
                component: () => import('@/components/waarnemingen/OverzichtWaarnemingen'),
                props: (route) => ({
                    id: route.params.id,
                    type: 'CV'
                }),
                meta: {
                    title: 'CV',
                    requiresAuth: true
                }
            },
            {
                path: 'waarnemingen/waarnemer/:id/snoverzicht',
                name: routeNames.WAARNEMINGEN_WAARNEMER_SN,
                component: () => import('@/components/waarnemingen/OverzichtWaarnemingen'),
                props: (route) => ({
                    id: route.params.id,
                    type: 'SN'
                }),
                meta: {
                    title: 'SN',
                    requiresAuth: true
                }
            },
            {
                path: 'waarnemingen/waarnemer/:id/ISoverzicht',
                name: routeNames.WAARNEMINGEN_WAARNEMER_IS,
                component: () => import('@/components/waarnemingen/OverzichtWaarnemingen'),
                props: (route) => ({
                    id: route.params.id,
                    type: 'IS'
                }),
                meta: {
                    title: 'IS',
                    requiresAuth: true
                }
            },
            {
                path: 'waarnemingen/waarnemer/:id/fakkeloverzicht',
                name: routeNames.WAARNEMINGEN_WAARNEMER_POOLFAKKEL,
                component: () => import('@/components/waarnemingen/OverzichtWaarnemingen'),
                props: (route) => ({
                    id: route.params.id,
                    type: 'fakkel'
                }),
                meta: {
                    title: 'Poolfakkels',
                    requiresAuth: true
                }
            },
            {
                path: 'waarnemingen/waarnemer/:id/wolfgrafiek',
                name: routeNames.WAARNEMINGEN_WAARNEMER_WOLF_GRAFIEK,
                component: () => import('@/components/waarnemingen/GrafiekWaarnemingen'),
                props: (route) => ({
                    id: route.params.id,
                    type: 'wolf'
                }),
                meta: {
                    title: 'Wolfgetal',
                    requiresAuth: true
                }
            },
            {
                path: 'waarnemingen/waarnemer/:id/beckgrafiek',
                name: routeNames.WAARNEMINGEN_WAARNEMER_BECK_GRAFIEK,
                component: () => import('@/components/waarnemingen/GrafiekWaarnemingen'),
                props: (route) => ({
                    id: route.params.id,
                    type: 'beck'
                }),
                meta: {
                    title: 'Beck',
                    requiresAuth: true
                }
            },
            {
                path: 'waarnemingen/waarnemer/:id/cvgrafiek',
                name: routeNames.WAARNEMINGEN_WAARNEMER_CV_GRAFIEK,
                component: () => import('@/components/waarnemingen/GrafiekWaarnemingen'),
                props: (route) => ({
                    id: route.params.id,
                    type: 'CV'
                }),
                meta: {
                    title: 'CV',
                    requiresAuth: true
                }
            },
            {
                path: 'waarnemingen/waarnemer/:id/sngrafiek',
                name: routeNames.WAARNEMINGEN_WAARNEMER_SN_GRAFIEK,
                component: () => import('@/components/waarnemingen/GrafiekWaarnemingen'),
                props: (route) => ({
                    id: route.params.id,
                    type: 'SN'
                }),
                meta: {
                    title: 'SN',
                    requiresAuth: true
                }
            },
            {
                path: 'waarnemingen/waarnemer/:id/ISgrafiek',
                name: routeNames.WAARNEMINGEN_WAARNEMER_IS_GRAFIEK,
                component: () => import('@/components/waarnemingen/GrafiekWaarnemingen'),
                props: (route) => ({
                    id: route.params.id,
                    type: 'IS'
                }),
                meta: {
                    title: 'IS',
                    requiresAuth: true
                }
            },
            {
                path: 'waarnemingen/waarnemer/:id/poolfakkelgrafiek',
                name: routeNames.WAARNEMINGEN_WAARNEMER_POOLFAKKEL_GRAFIEK,
                component: () => import('@/components/waarnemingen/GrafiekWaarnemingen'),
                props: (route) => ({
                    id: route.params.id,
                    type: 'fakkel'
                }),
                meta: {
                    title: 'Poolfakkels',
                    requiresAuth: true
                }
            },
            {
                path: 'waarnemingen/gegevens/waarnemer/:id',
                name: routeNames.GEGEVENS_WAARNEMER_SELECTIE,
                component: () => import('@/components/formulieren/DataWaarnemerSelectie'),
                meta: {
                    title: 'GegevensVanWaarnemer',
                    requiresAuth: true
                }
            },
            {
                path: 'waarnemingen/gegevens/edit/waarnemer/:id',
                name: routeNames.GEGEVENS_WAARNEMER_EDIT_WAARNEMER,
                component: () => import('@/components/dataWaarnemer/EditGegevensWaarnemer'),
                meta: {
                    title: 'GegevensVanWaarnemer',
                    requiresAuth: true
                }
            },
            {
                path: 'waarnemingen/gegevens/edit/telescoop/:id',
                name: routeNames.GEGEVENS_WAARNEMER_EDIT_TELESCOOP,
                component: () => import('@/components/dataWaarnemer/EditGegevensTelescoop'),
                meta: {
                    title: 'GegevensVanTelescoop',
                    requiresAuth: true
                }
            },
            {
                path: 'waarnemingen/uploaden/excel/:id',
                name: routeNames.WAARNEMINGEN_EXCEL_UPLOADEN,
                component: () => import('@/components/waarnemingen/upload/UploadenExcel'),
                meta: {
                    title: 'WaarnemingenExcel',
                    requiresAuth: true
                }
            },
            {
                path: 'waarnemingen/maand/waarnemer',
                name: routeNames.WAARNEMER_MAAND,
                component: () => import('@/components/waarnemingen/WaarnemingenVanMaand'),
                meta: {
                    title: 'excelWaarnemer',
                    requiresAuth: true
                }
            },
            {
                path: 'waarnemingen/rapporten',
                name: routeNames.RAPPORTEN,
                component: () => import('@/components/waarnemingen/MaandRapportTabellen'),
                meta: {
                    title: 'Rapporten',
                    requiresAuth: true,
                    requiresAdmin: true
                }
            },
            {
                path: 'berichtVerzenden',
                name: routeNames.BERICHT_VERZENDEN,
                component: () => import('@/components/notifications/VerzendBoodschap.vue'),
                meta: {
                    title: 'Bericht',
                    requiresAuth: true
                }
            },
            {
                path: 'waarnemers',
                name: routeNames.WAARNEMERS_OVERZICHT,
                component: () => import('@/components/dataWaarnemer/OverzichtWaarnemers'),
                meta: {
                    title: 'overzichtWaarnemers',
                    requiresAuth: true,
                    requiresAdmin: true
                }
            },
            {
                path: 'waarnemers/data/aanpassen/:id',
                name: routeNames.ADMIN_WIJZIG_DATA_WAARNEMER,
                component: () => import('@/components/formulieren/WaarnemerDataWijzigen'),
                meta: {
                    title: 'AanpassenGegevensWaarnemer',
                    requiresAuth: true,
                    requiresAdmin: true
                }
            },
            {
                path: 'waarnemers/waarnemingen/aanpassen/:naam/:id',
                name: routeNames.ADMIN_WAARNEMINGEN_VAN_WAARNEMER,
                component: () => import('@/components/waarnemingen/WaarnemingenVanWaarnemer'),
                meta: {
                    title: 'AanpassenWaarnemingenWaarnemer',
                    requiresAuth: true,
                    requiresAdmin: true
                }
            },
            {
                path: 'waarnemingen/maandrapport',
                name: routeNames.MAANDRAPPORT,
                component: () => import('@/components/waarnemingen/MaandRapport'),
                meta: {
                    title: 'GenereerMaandrapport',
                    requiresAuth: true,
                    requiresAdmin: true
                }
            },
            {
                path: 'instellingen',
                name: routeNames.PARAMETERS_OVERZICHT,
                component: () => import('@/components/logica/Parameters'),
                meta: {
                    title: 'InstellingenApp',
                    requiresAuth: true,
                    requiresAdmin: true
                }
            },
            {
                path: 'developper',
                name: routeNames.DEVELOP_TOOLS,
                component: () => import('@/components/developer/develop'),
                meta: {
                    title: 'Developer',
                    requiresAuth: true,
                    requiresDeveloper:true
                }
            },
        ]
    },
    {
        path: '/about',
        name: 'about',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    },
    {
        path: '*',
        redirect: '/'
    },
]

const router = new VueRouter({
    routes
})

export default router


router.beforeEach(async (to, from, next) => {

    const isAuth = store.getters['authModule/isAuthenticated']
    const tokenExists = hasValidToken()

    // --- HYDRATION AFTER REFRESH ---
    if (tokenExists && !isAuth) {
        const keepLoggedIn = localStorage.getItem('keepLoggedIn') === 'true'
        const storage = keepLoggedIn ? localStorage : sessionStorage
        const user = storage.getItem('user')
        if (user) {
            store.commit('authModule/setUser', JSON.parse(user))
            store.commit('authModule/setKeepLoggedIn', keepLoggedIn)
        }
    }

    // --- LOGIN PAGE ---
    if (to.path === '/login') {
        if (isAuth) {
            return next({
                name: routeNames.KALENDER,
                params: { date: new Date().toISOString().slice(0,10) }
            })
        }
        return next()
    }

    // --- PROTECTED ROUTES ---
    if (to.matched.some(r => r.meta.requiresAuth)) {
        if (!isAuth) {
            return next('/login')
        }
    }

    // --- ADMIN ---
    if (to.matched.some(r => r.meta.requiresAdmin)) {
        await ensureAdminInfoLoaded()
        const rolNaam = getUserRole()
        if (!['admin', 'develop'].includes(rolNaam)) {
            return next({
                name: routeNames.KALENDER,
                params: { date: new Date().toISOString().slice(0,10) }
            })
        }
    }

    next()
})

function hasValidToken() {
    const token =
        localStorage.getItem('refreshToken') ||
        sessionStorage.getItem('refreshToken')

    if (!token) return false

    try {
        const payload = JSON.parse(atob(token.split('.')[1]))
        return payload.exp * 1000 > Date.now()
    } catch {
        return false
    }
}

function getUserRole() {
    const waarnemer = store.state.waarnemersModule.waarnemer
    const rolId = waarnemer?.rolId
    const name = store.getters['rollenModule/getRolNaamById'](rolId)

    return name ? name.toLowerCase().trim() : null
}

async function ensureAdminInfoLoaded() {
    let waarnemer = store.state.waarnemersModule.waarnemer

    if (!waarnemer) {
        const email = store.state.authModule.user?.email
        if (email) {
            await store.dispatch('waarnemersModule/fetchWaarnemerMetEmail', email)
            waarnemer = store.state.waarnemersModule.waarnemer
        }
    }
    if (!store.state.rollenModule.rollen) {
        await store.dispatch('rollenModule/fetchRollen')
    }
}


